// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[dir] .wrap-functions {\n  border: 1px solid #673ab721;\n  border-radius: 5px;\n  padding: 6px 5px;\n  margin: 4px 0;\n}\n", ""]);
// Exports
module.exports = exports;
